import { HlaLane } from "./HlaLane";
import { HlaWay, HlaWayType } from "./HlaWay";
import { SimulationLane } from "./SimulationLane";
import { SimulationWay } from "./SimulationWay";

export type AttributeChange = {
  key: string;
  label: string;
  hlaValue: unknown;
  simulationValue: unknown;
};

export interface WayLike {
  lit: boolean;
  averageRoadSpeed: number | null;
  averageDailyTraffic: number | null;
  type: HlaWayType;
}

export type Lane = HlaLane | SimulationLane;

export type LaneFacing = "front" | "back";

export const FACING_LABEL: Record<LaneFacing, string> = {
  front: "Front-facing lane",
  back: "Back-facing lane",
};

export const ATTRIBUTE_LABELS: Record<string, string> = {
  adjacentFeaturesLeft: "Adjacent features left",
  adjacentFeaturesRight: "Adjacent features right",
  roadLane: "Road lane",
  numberOfLanes: "Number of lanes",
  vehicleParking: "Vehicle parking",
  sidewalk: "Sidewalk",
  objectOrLevelChange: "Object or level change",
  severeHazard: "Severe hazard",
  hardSegregation: "Hard segregation",
  facilityType: "Facility type",
  flowDirection: "Flow direction",
  facilityWidthPerDirection: "Facility width per direction",
  lightSegregation: "Light segregation",
  tramOrTrainRails: "Tram/train rails",
  averageDailyTraffic: "AADT",
  averageRoadSpeed: "Average road speed",
  heavyVehicleFlow: "Heavy vehicle flow",
  lit: "Street lighting",
  type: "Way type",
};

export const WAY_FIELDS: {
  key: keyof HlaWay & keyof SimulationWay;
  label: string;
}[] = [
  { key: "type", label: "Way type" },
  { key: "heavyVehicleFlow", label: "Heavy vehicle flow" },
  { key: "averageRoadSpeed", label: "Average road speed" },
  { key: "averageDailyTraffic", label: "AADT" },
  { key: "lit", label: "Street lighting" },
];

export const LANE_FIELDS: {
  key: keyof HlaLane & keyof SimulationLane;
  label: string;
}[] = [
  { key: "adjacentFeaturesLeft", label: "Adjacent features left" },
  { key: "adjacentFeaturesRight", label: "Adjacent features right" },
  { key: "flowDirection", label: "Flow direction" },
  { key: "facilityType", label: "Facility type" },
  { key: "facilityWidthPerDirection", label: "Facility width per direction" },
  { key: "lightSegregation", label: "Light segregation" },
  { key: "tramOrTrainRails", label: "Tram/train rails" },
];
